export const NAME = 'KYC';